import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Statistic } from 'antd';
import { 
  UserOutlined, 
  FileTextOutlined, 
  ExclamationCircleOutlined,
  CheckCircleOutlined 
} from '@ant-design/icons';
import { statsAPI } from '../api/stats';

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const res = await statsAPI.getOverview();
      setStats(res.data);
    } catch (error) {
      console.error('加载统计数据失败:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div>加载中...</div>;
  if (!stats) return <div>暂无数据</div>;

  return (
    <div>
      <h2 style={{ marginBottom: 24 }}>数据概览</h2>
      
      <div style={{ marginBottom: 32 }}>
        <h3 style={{ marginBottom: 16 }}>今日数据</h3>
        <Row gutter={16}>
          <Col span={6}>
            <Card>
              <Statistic
                title="新增用户"
                value={stats.today.newUsers}
                prefix={<UserOutlined />}
                valueStyle={{ color: '#3f8600' }}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic
                title="新增帖子"
                value={stats.today.newPosts}
                prefix={<FileTextOutlined />}
                valueStyle={{ color: '#1890ff' }}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic
                title="待审核帖子"
                value={stats.today.pendingPosts}
                prefix={<ExclamationCircleOutlined />}
                valueStyle={{ color: '#fa8c16' }}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic
                title="待处理举报"
                value={stats.today.pendingReports}
                prefix={<ExclamationCircleOutlined />}
                valueStyle={{ color: '#cf1322' }}
              />
            </Card>
          </Col>
        </Row>
      </div>

      <div>
        <h3 style={{ marginBottom: 16 }}>总体数据</h3>
        <Row gutter={16}>
          <Col span={6}>
            <Card>
              <Statistic
                title="总用户数"
                value={stats.total.users}
                prefix={<UserOutlined />}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic
                title="总帖子数"
                value={stats.total.posts}
                prefix={<FileTextOutlined />}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic
                title="封禁用户"
                value={stats.total.bannedUsers}
                prefix={<ExclamationCircleOutlined />}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic
                title="违规帖子"
                value={stats.total.violationPosts}
                prefix={<CheckCircleOutlined />}
              />
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Dashboard;
